// Estilos compartidos para campos de formulario (coherencia visual en todo el ecosistema).

export const inputClass =
  "w-full bg-background-100/70 border border-background-300/50 rounded-md px-3 py-2 text-sm text-foreground-950 placeholder:text-foreground-500 outline-none focus:border-accent-500/50 focus:ring-2 focus:ring-accent-500/25";

export const labelClass = "block text-[11px] font-semibold text-foreground-600 mb-1";

export const primaryButtonClass =
  "px-4 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm font-semibold whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2";

export const ghostButtonClass =
  "px-4 py-2.5 rounded-md border border-accent-500/35 text-accent-200 hover:bg-accent-500/10 text-sm font-semibold whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2";